import { IncomingHttpHeaders } from 'http'
import { Locale } from '../constants/languageHelpers'

const DEFAULT_LOCALE = Locale.RU

export const getXHost = (headers: IncomingHttpHeaders = {}) => {
  return ((headers['x-host'] as string) || DEFAULT_LOCALE).replace(/\..*/gi, '')
}
